export default __webpack_public_path__ + "static/media/success-svgrepo-com-color.be7c5034.svg";